import React, { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useDemoMode } from "../../../../contexts/DemoModeContext";
import {
  BannerSubtitle,
  BannerTitle,
  Frame,
  FrameHeader,
  HideButton,
} from "./DemoShipments.styles";

interface DemoFrameProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

// Shared shell for every demo surface: banner text and sample rows sit in one
// tinted, dashed-outlined region so the "not real data" signal is ambient, with
// a one-click opt-out mirroring Account settings (localStorage only, no API).
const DemoFrame: FC<DemoFrameProps> = ({ title, subtitle, children }) => {
  const { t } = useTranslation("common");
  const { setDemoEnabled } = useDemoMode();

  const handleHide = () => {
    setDemoEnabled(false);
    toast.info(t("parcels.demo.hideConfirmation"), {
      toastId: "demo-hidden",
      icon: false,
    });
  };

  return (
    <Frame>
      <FrameHeader>
        <BannerTitle>{title}</BannerTitle>
        <BannerSubtitle>{subtitle}</BannerSubtitle>
        <HideButton type="button" onClick={handleHide}>
          {t("parcels.demo.hide")}
        </HideButton>
      </FrameHeader>
      {children}
    </Frame>
  );
};

export default DemoFrame;
